export const getCoaches = (coaches = []) => {
  return coaches.reduce((a, b) => {
    return a.length ? `${a}, ${b.name}` : b.name
  }, "")
}
